import { InfoOutlined } from '@mui/icons-material';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Tooltip, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { Control, Controller } from 'react-hook-form';
import { EditVisitorGroupsFormValues } from '../drawers/EditVisitorGroupsDrawer';

interface Props {
  control: Control<EditVisitorGroupsFormValues>;
  canEditAdministratorRole: boolean;
  isAdministratorsGroupFull?: boolean;
  isInstallersGroupFull?: boolean;
}

const VisitorRolesSection = ({
  canEditAdministratorRole,
  control,
  isAdministratorsGroupFull,
  isInstallersGroupFull
}: Props) => {
  const { translation } = useTranslation();

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" sx={{ mb: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
        {translation.roles}
        <Tooltip title={<Typography variant="body2">{translation.toggle_group_role_hint}</Typography>}>
          <InfoOutlined fontSize="small" />
        </Tooltip>
      </FormLabel>
      <FormGroup>
        {canEditAdministratorRole && (
          <Controller
            name="isAdministratorRole"
            control={control}
            render={({ field }) => {
              const isDisabled = !field.value && !!isAdministratorsGroupFull;
              return (
                <Tooltip title={isDisabled ? translation.group_is_full : ''}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={field.value}
                        onChange={field.onChange}
                        color="primary"
                        id="drawer-input-isAdministratorRole-checkbox"
                        disabled={isDisabled}
                      />
                    }
                    label={translation.administrator}
                  />
                </Tooltip>
              );
            }}
          />
        )}
        <Controller
          name="isInstallerRole"
          control={control}
          render={({ field }) => {
            const isDisabled = !field.value && !!isInstallersGroupFull;
            return (
              <Tooltip title={isDisabled ? translation.group_is_full : ''}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={field.value}
                      onChange={field.onChange}
                      color="primary"
                      id="drawer-input-isInstallerRole-checkbox"
                      disabled={isDisabled}
                    />
                  }
                  label={translation.installer}
                />
              </Tooltip>
            );
          }}
        />
      </FormGroup>
    </FormControl>
  );
};

export default VisitorRolesSection;
